import { API } from '@/api'
import { MfaProofType } from '@/consts/mfa'
import { RequestConf } from '@/utils/http'

const silentRequest: RequestConf = { errMsg: false }

export class MfaService {
  static async getStatus() {
    const res = await API.getTotpStatus(undefined, silentRequest)
    if (res.code === 0) {
      return res.status
    }
    throw new Error(res.msg || 'Failed to get MFA status')
  }

  static async setup() {
    const res = await API.setupTotp(undefined, silentRequest)
    if (res.code === 0) {
      return res.setup
    }
    throw new Error(res.msg || 'Failed to set up MFA')
  }

  static async enable(code: string) {
    const res = await API.enableTotp({ code }, silentRequest)
    if (res.code === 0) {
      return res.status
    }
    return { code: res.code, msg: res.msg }
  }

  static async disable(proofType: MfaProofType, proof: string) {
    const res = await API.disableTotp({ proof_type: proofType, proof }, silentRequest)
    if (res.code === 0) {
      return { code: 0 as const }
    }
    return { code: res.code, msg: res.msg }
  }
}
